
import { defineComponent } from "vue";

export default defineComponent({
  props: { tile: { type: Object, required: true } },
});
